import { Button, Tabs } from "antd"
import { initUrlQuery, searchAll } from "api/jjzq"
import Footer from "comps/Footer"
import Header from "comps/Header"
import {
  CondBar,
  FilterPanel,
  MarketTable,
  toServerParam,
  useQuery
} from "comps/Jjzq"
import JjzqH5Content from "comps/JjzqH5"
import Layout from "comps/Layout"
import { useGtZeroEffect } from "hooks/useGtZeroEffect"
import { tabs } from "libs/cons"
import { MediaQueryContext, UserContext } from "libs/contexts"
import { useContext, useRef, useState } from "react"

const { TabPane } = Tabs
const BiddingPath = "/portal/tender/purchaser/competition/create"
export default function JjzqIndex(props) {
  const { isMobile } = useContext(MediaQueryContext)
  // TODO TDK
  return (
    <Layout
      header={!isMobile && <Header />}
      footer={!isMobile && <Footer />}
      title="竞价专区"
      keywords=""
      description=""
      showFixedMenu
    >
      {isMobile ? (
        <JjzqH5Content {...props} extraHeight={102} clearComps={false} />
      ) : (
        <PcContent {...props} />
      )}
    </Layout>
  )
}

function PcContent({ condition, hotAreas, otherAreas, mainSSData }) {
  const tableRef = useRef(null)
  const userInfo = useContext(UserContext)
  const [mainData, setMainData] = useState(mainSSData)
  const { query, push } = useQuery()
  const type = (query.type ? query.type : initUrlQuery.type) as string
  function onChangeTab(key) {
    push(
      {
        keyword: query.keyword as string,
        type: key,
        pageNo: 1,
        // 清空以下参数
        sortType: "",
        status: "",
      },
      true,
    )
  }

  // 首次服务端请求
  useGtZeroEffect(() => {
    ;(async () => {
      try {
        tableRef?.current?.setLoading(true)
        let res: any = await searchAll({
          json: toServerParam(query, initUrlQuery.pageSize, true),
          method: "POST",
        })
        if (res?.code === 200) {
          setMainData(res?.data)
        }
      } finally {
        tableRef?.current?.setLoading(false)
      }
    })()
  }, [query])

  return (
    <div className="pc-page">
      <div className="tab-box">
        <Tabs activeKey={type as string} onChange={onChangeTab}>
          {tabs.map((item) => {
            return <TabPane tab={item.name} key={item.key}></TabPane>
          })}
        </Tabs>
        <a
          className="tab-box-btn"
          onClick={() => {
            window.open("/purchaser/trade/shopFastCreate")
          }}
        >
          <Button type="primary">竞价下单</Button>
        </a>
        {/* <a
          className="tab-box-btn"
          style={{right: '100px'}}
          onClick={() => {
            window.open("/purchaser/trade/shopFastCreate?isPricing=true")
          }}
        >
          <Button type="primary">新竞价下单</Button>
        </a> */}
      </div>
      <FilterPanel
        queryKey="categories"
        name="品类"
        condition={condition?.categories}
      />
      <CondBar
        total={mainData.total}
        hotAreas={hotAreas}
        otherAreas={otherAreas}
      />
      <MarketTable list={mainData} ref={tableRef} />
      <style jsx>{`
        .pc-page {
          width: 1200px;
          margin: 0 auto 20px;
          min-height: 450px;
        }
        .tab-box {
          position: relative;
          margin-top: 10px;
          user-select: none;
        }
        .tab-box .tab-box-btn {
          position: absolute;
          top: 6px;
          right: 0;
          z-index: 99;
        }
        .tab-box :global(.ant-tabs-tab) {
          font-size: 16px;
        }
        .tab-box :global(.ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn) {
          text-shadow: initial;
        }
        .tab-box :global(.ant-tabs-tab-btn:hover) {
          font-weight: 500;
          color: var(--primaryColor);
        }
        .tab-box :global(.ant-tabs-tab + .ant-tabs-tab) {
          margin-left: 50px;
        }
        .tab-box :global(.ant-tabs-tab-active) {
          font-weight: 500;
        }
        .tab-box :global(.ant-tabs-top > .ant-tabs-nav) {
          margin-bottom: 0;
        }
      `}</style>
    </div>
  )
}
